import Auth from "./Auth";
import Franquias from "./Franquias";
import MainTemplate from "./MainTemplate";
import Usuarios from "./Usuarios";
import Roles from "./Roles";
import AppConfigurations from "./AppConfigurations";

export default {
  Auth,
  Franquias,
  MainTemplate,
  Usuarios,
  Roles,
  AppConfigurations,
};
